import { TMeasurementQcActions, MeasurementQcDBActionTypes } from './measurement-qc.actions';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { TMeasurementQcDB } from '@monorepo/types';

export function getMeasurementQcInitialState(nextCacheResetTimestamp: number): TMeasurementQcDB {
  return {
    nextCacheResetTimestamp,
    lastFetchedTagData: null,
    lastMeasuredTagData: null,
    bctxMap: {},
  };
}

export function MeasurementQcStateReducer(
  state: TMeasurementQcDB = getMeasurementQcInitialState(INITIAL_CACHE_RESET_TIMESTAMP),
  action: TMeasurementQcActions,
): TMeasurementQcDB {
  switch (action.type) {
    case MeasurementQcDBActionTypes.SetMeasurementQcDB:
      return action.db;
    default:
      return state;
  }
}
